import { useCallback } from 'react';
import { signupEvent } from 'services/gtag';

export function useGTagTrackCompleteRegistration() {
  const gtagTrackConsumerSignup = useCallback(() => {
    if (process.env.USE_GTAG) {
      signupEvent();
    }
  }, []);

  return { gtagTrackConsumerSignup };
}
